// extracted by mini-css-extract-plugin
export default {"edit_post":"EditPost_edit_post__SyjJW","previewText":"EditPost_previewText__sgDO3","previewImage":"EditPost_previewImage__gmYI9"};